import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/airplaneticket/img/rights/aira.png")